export default "__VITE_ASSET__OGsnhqju__"